// plan-16 S02: shell-style tokenizer for filesystem paths
// Handles: unquoted words, "double quoted", 'single quoted', backslash\ escape

export interface Token {
  value: string
  raw: string
}

export function tokenize(input: string): Token[] {
  const tokens: Token[] = []
  let i = 0

  while (i < input.length) {
    // skip whitespace
    if (input[i] === ' ' || input[i] === '\t') {
      i++
      continue
    }

    const token = readToken(input, i)
    if (token) {
      tokens.push(token)
      i += token.raw.length
    }
  }

  return tokens
}

function readToken(input: string, start: number): Token | null {
  let i = start
  let value = ''
  const rawParts: string[] = []

  while (i < input.length) {
    const ch = input[i]

    if (ch === ' ' || ch === '\t') {
      break
    } else if (ch === '"') {
      // double-quoted string
      const end = input.indexOf('"', i + 1)
      if (end === -1) {
        // unterminated — take rest
        value += input.slice(i + 1)
        rawParts.push(input.slice(i))
        i = input.length
      } else {
        value += input.slice(i + 1, end)
        rawParts.push(input.slice(i, end + 1))
        i = end + 1
      }
    } else if (ch === "'") {
      // single-quoted string
      const end = input.indexOf("'", i + 1)
      if (end === -1) {
        value += input.slice(i + 1)
        rawParts.push(input.slice(i))
        i = input.length
      } else {
        value += input.slice(i + 1, end)
        rawParts.push(input.slice(i, end + 1))
        i = end + 1
      }
    } else if (ch === '\\') {
      // backslash escape
      if (i + 1 < input.length) {
        value += input[i + 1]
        rawParts.push(input.slice(i, i + 2))
        i += 2
      } else {
        value += '\\'
        rawParts.push('\\')
        i++
      }
    } else {
      // unquoted character
      value += ch
      rawParts.push(ch)
      i++
    }
  }

  if (value.length === 0 && rawParts.length === 0) return null

  return { value, raw: rawParts.join('') }
}
